import Vue from 'vue'
import Router from 'vue-router'

import Live from "./components/live/index"
import Store from "./components/store/index"
import SmallVideo from "./components/video/index"
import Subject from "./components/subject/index"
import Important from "./components/important/index"
import ChannelList from "./components/channelList/index"
import Study from "./components/study/index"
import pc from "./components/study/pc"
import StudyDetail from "./components/study/page/studyDetail"
import Course from "./components/study/page/course"
import Classifiy from "./components/study/page/classifiy"
import TeachList from "./components/study/page/teachList"
import MzlList from "./components/study/page/mzlList"
import MzlDetail from "./components/study/page/mzlDetail"
import Dishi from "./components/study/page/dishi"
import YiQing from "./components/video/yiqing/index"
import Minzhulu2020 from "./components/video/mzlxx2020/index"
import ZQC from "./components/video/zqc/index"
import Weike from "./components/weike/index"
import finance from "./components/finance/index"
import SelectGrade from "./components/weike/selectgrade"
import WkDetail from "./components/weike/wkdetail"
import weikeList from "./components/weike/weikeList"
import Child from "./components/study/page/child"
import ChildTeachList from "./components/study/page/childteachlist"
import ChildStudyDetail from "./components/study/page/childstudydetail"
import Xueersi from "./components/study/page/xueersi"
import XueDetail from "./components/study/page/xuedetail"
import XueTeachList from "./components/study/page/xueersiteachlist"
import YunDangke from "./components/study/page/yundangke"
import YunDangkeList from "./components/study/page/yundangkeList"
import travel from "./components/travel"
import gift from "./components/gift"
import job from "./components/job"
import Gxnewsmore from "./components/gxnews/more"
import buyhouse from "./components/buyhouse/index"
import houselist from "./components/buyhouse/houselist"
import houselist2 from "./components/buyhouse/houselist2"
import poverty from "./components/poverty/index"
Vue.use(Router)

export default new Router({
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/store',
            name: 'Store',
            component: Store
        },
        {
            path: '/live/:id/',
            name: 'Live',
            component: Live
        },
        {
            path: '/video/:id/',
            name: 'SmallVideo',
            component: SmallVideo
        },
        {
            path: '/video-yiqing',
            name: 'YiQing',
            meta: {
                title: '【在线抗“疫”· 筑青春长城】广西志愿服务Vlog'
            },
            component: YiQing
        },
        {
            path: '/video-zqc',
            name: 'ZQC',
            meta: {
                title: '致青春 · 为家国——第二届广西青少年经典云共读活动'
            },
            component: ZQC
        },
        {
            path: '/video-mzlxx2020',
            name: 'MZL2020',
            meta: {
                title: '南宁市民主路小学建校65周年校庆——我为母校送祝福'
            },
            component: Minzhulu2020
        },
        {
            path: '/subject/:id/',
            name: 'Subject',
            component: Subject
        },
        {
            path: '/important',
            name: 'Important',
            component: Important
        },
        {
            path: '/channelList/:id',
            name: 'ChannelList',
            component: ChannelList
        },
        {
            path: '/study',
            name: 'Study',
            component: Study
        },
        {
            path: '/study/pc',
            name: 'pc',
            component: pc
        },
        {
            path: '/studyDetail/:name/:id/:sortid?',
            name: 'StudyDetail',
            component: StudyDetail
        },
        {
            path: '/course/:title',
            name: 'Course',
            component: Course
        },
        {
            path: '/classifiy/:title/:sortid',
            name: 'Classifiy',
            component: Classifiy
        },
        {
            path: '/teachList/:name/:sortid',
            name: 'TeachList',
            component: TeachList
        },
        {
            path: '/mzlList/:sortid',
            name: 'MzlList',
            component: MzlList
        },
        {
            path: '/mzlDetail/:id/:sortid?',
            name: 'MzlDetail',
            component: MzlDetail
        },
        {
            path: '/dishi/:name/:city',
            name: 'Dishi',
            component: Dishi
        },
        {
            path: '/weike',
            name: 'weike',
            component: Weike
        },
        {
            path: '/selectgrade',
            name: 'selectgrade',
            component: SelectGrade
        },
        {
            path: '/finance',
            name: 'finance',
            component: finance
        },
        {
            path: '/wkdetail/:name/:resId',
            name: 'wkdetail',
            component: WkDetail
        },
        {
            path: '/weikelist/:grade/:id',
            name: 'weikeList',
            component: weikeList
        },
        {
            path: '/child/:title',
            name: 'Child',
            component: Child
        },
        {
            path: '/childteachlist/:name/:sortid',
            name: 'ChildTeachList',
            component: ChildTeachList
        },
        {
            path: '/childstudydetail/:name/:id/:sortid?',
            name: 'ChildStudyDetail',
            component: ChildStudyDetail
        },
        /*{
            path: '/xueersi',
            name: 'Xueersi',
            component: Xueersi
        },
        {
            path: '/xueersi/:sortid/:id',
            name: 'XueDetail',
            component: XueDetail
        },
        {
            path: '/xueersi/:sortid',
            name: 'XueTeachList',
            component: XueTeachList
        },*/
        {
            path: '/yundangke',
            name: 'YunDangke',
            component: YunDangke
        },
        {
            path: '/yundangkelist/:name/:cateid',
            name: 'YunDangkeList',
            component: YunDangkeList
        },
        {
            path: '/travel',
            name: 'travel',
            component: travel
        },
        {
            path: '/gift',
            name: 'gift',
            component: gift
        },
        {
            path: '/job',
            name: 'job',
            component: job
        },
        {
            path: '/gxnews/more/:sortid',
            name: 'gxnewsmore',
            component: Gxnewsmore
        },
        {
            path: '/buyhouse',
            name: 'buyhouse',
            meta: {
                title: '购房365'
            },
            component: buyhouse
        },
        {
            path: '/houselist',
            name: 'houselist',
            meta: {
                title: '购房365'
            },
            component: houselist
        },
        {
            path: '/houselist2',
            name: 'houselist2',
            meta: {
                title: '购房365'
            },
            component: houselist2
        },
        {
            path: '/poverty',
            name: 'poverty',
            meta: {
                title: '脱贫'
            },
            component: poverty
        }
    ]
})